import httpClient from './httpClient';
import type { PaginatedResult } from '@/types';
import type {
  InvoiceListItem,
  InvoiceDetail,
  InvoiceFilters,
  CreateInvoiceRequest,
  RecordPaymentRequest,
  ArSummaryItem,
} from '@/types/finance';

export const financeApi = {
  // ── Invoices ──────────────────────────────────────────────

  async getInvoices(
    mdFilters: InvoiceFilters
  ): Promise<PaginatedResult<InvoiceListItem>> {
    const mdParams: Record<string, string | number | boolean> = {
      page: mdFilters.page,
      pageSize: mdFilters.pageSize,
    };
    if (mdFilters.search) mdParams.search = mdFilters.search;
    if (mdFilters.customerId) mdParams.customerId = mdFilters.customerId;
    if (mdFilters.status) mdParams.status = mdFilters.status;
    if (mdFilters.overdue !== undefined) mdParams.overdue = mdFilters.overdue;
    if (mdFilters.dateFrom) mdParams.dateFrom = mdFilters.dateFrom;
    if (mdFilters.dateTo) mdParams.dateTo = mdFilters.dateTo;

    const mdResponse = await httpClient.get<PaginatedResult<InvoiceListItem>>(
      '/invoices',
      { params: mdParams }
    );
    return mdResponse.data;
  },

  async getInvoiceById(mdId: string): Promise<InvoiceDetail> {
    const mdResponse = await httpClient.get<InvoiceDetail>(`/invoices/${mdId}`);
    return mdResponse.data;
  },

  /** Повертає Guid створеного рахунку */
  async createInvoice(mdRequest: CreateInvoiceRequest): Promise<string> {
    const mdResponse = await httpClient.post<string>('/invoices', mdRequest);
    return mdResponse.data;
  },

  async issueInvoice(mdId: string): Promise<void> {
    await httpClient.post(`/invoices/${mdId}/issue`);
  },

  async cancelInvoice(mdId: string, mdReason: string): Promise<void> {
    // Тіло необов'язкове (CancelInvoiceCommand { id, reason }); id маршруту має пріоритет
    await httpClient.post(`/invoices/${mdId}/cancel`, { id: mdId, reason: mdReason });
  },

  /** Повертає Guid створеної оплати */
  async recordPayment(mdRequest: RecordPaymentRequest): Promise<string> {
    const mdResponse = await httpClient.post<string>(
      `/invoices/${mdRequest.invoiceId}/payments`,
      mdRequest
    );
    return mdResponse.data;
  },

  // ── Accounts Receivable ────────────────────────────────────

  async getArSummary(): Promise<ArSummaryItem[]> {
    const mdResponse = await httpClient.get<ArSummaryItem[]>('/invoices/ar-summary');
    return mdResponse.data;
  },
};
